export const enum WebViewAdapterEventSubscription {
    AvailabilityCheckType = 'CALL_FEATURE_AVAILABILITY',
    AndroidOtpCode = 'ANDROID_OTP_CODE',
    SapphireContacts = 'SAPPHIRE_CONTACTS',
    AndroidContacts = 'ANDROID_CONTACTS',
    IosContacts = 'IOS_CONTACTS',
    WebviewVisibilityChange = 'VISIBILITY_CHANGE',
    RINGER_MODE = 'RINGER_MODE',
    LUNA_RINGER_MODE = 'SAPPHIRE_RINGER_MODE',
}

/**
 * Эвенты WebviewAdaptera
 * @readonly
 * @enum {string}
 */
export const enum WebViewAdapterEventSendable {
    ExecuteCall = 'executeCallHandler',
    AvailabilityCheck = 'callFeatureAvailabilityHandler',
    CallError = 'callErrorHandler',
    SubscribeAndroidOtpSms = 'smsOtpAndroidHybridHandler',
    PhoneNumberHandler = 'phoneNumberHandler',
    WebviewVisibilityTrackerHandler = 'visibilityTrackerHandler',
    StatusBarSegmentColor = 'statusBarSegmentColor',
    /** postmessage для обновление счетчика непрочитанных сообщений в гибрид+ */
    UpdateCounter = 'chatUnreadMessagesHandler',
    HybridRingerModeHandler = 'ringerModeHandler',
    LunaRingerModeHandler = 'ringerModeHandler',
}

export const enum WebViewAdapterEventError {
    Timeout = 'WEBVIEW_LISTEN.TIMEOUT_ERROR',
    AvailabilityTimeout = 'AVAILABILITY_TIMEOUT_ERROR',
}
